import memoizeWith from 'ramda.memoizewith'

export const preload = memoizeWith(source => source, source => fetch(source))
